import { config, george, observer, pr, React, theme, ui } from "aaa";
import { SIdentityStore } from "components/sidentity/SIdentityStore";
import { SIdentitySettingsStore } from "components/sIdentitySettings/SIdentitySettingsStore";
import { isInRange, isNumber, localizedNumber, maxDecimal } from "util/formValidations";
import { CardTanSettingsStore } from "components/loginManagement/cardTanSettings/CardTanSettingsStore";

const ChooseSIdentityLimitComponent = observer((props: {
    store: SIdentityStore | SIdentitySettingsStore | CardTanSettingsStore,
    name: string
}) => {
    const textFieldDisabled = props.store.withoutLimit;

    // Resize for smaller phones
    let fontSize = pr.STYLE_CENTERED_TEXT_FIELD.fontSize as number;
    const valueString = props.store.limit.toString().replace(".", "");
    if (valueString.length > 11 && ui.windowWidth < 400) {
        fontSize *= ui.windowWidth / 400;
    }

    const limitValue = props.store.limit !== 0 && String(props.store.limit).replace(".", config.CURRENCY_DECIMAL_SEPARATOR);

    return (
        <>
            <george.RadioButton
                defaultChecked={props.store.withoutLimit}
                onCheck={(event: any, checked: boolean) => {
                    props.store.withoutLimit = checked;
                }}
                labelYes={ui.__("sidentity.limit.radio.yes")}
                labelNo={ui.__("sidentity.limit.radio.no")}
                radioButtonStyle={{
                    fontSize: 16
                }}
            />

            <george.TextFieldFormsy
                name={props.name}
                required
                inputValidations={[isNumber, isInRange(0, 10000000000000), maxDecimal(2)]}
                // only disabled if the checkbox is checked
                disabled={textFieldDisabled}
                hintText={props.store.withoutLimit ? ui.__("sidentity.limit.placeholder.text") : undefined}
                decorator="EUR"
                onChange={(value: string) => {
                    props.store.limit = localizedNumber(value);
                }}
                inputStyle={{
                    ...pr.STYLE_LIGHT_28,
                    fontSize
                }}
                value={props.store.withoutLimit ? "" : limitValue}
                aria-label={props.store.withoutLimit ? undefined : ui.__("a11y.sidentity.limit.euro.label")}
                inputMode="decimal"
            />
        </>
    );
});

export const ChooseSIdentityLimitEmbedded = observer((props: {
    store: SIdentityStore | SIdentitySettingsStore | CardTanSettingsStore,
    name: string,
    padding?: number | string,
}) => (
        <>
            <div style={{ padding: props.padding }}>
                <george.SectionTitle style={{ marginTop: 0 }}>
                    {ui.__("sidentity.limit.header")}
                </george.SectionTitle>
                <pr.P_14_CONTENT>
                    {ui.__("sidentity.limit.subtitle.text")}
                </pr.P_14_CONTENT>
            </div>
            <pr.LightSeparatorLine style={{ marginTop: theme.MARGIN }} />
            <div style={{ padding: props.padding }}>
                <ChooseSIdentityLimitComponent store={props.store} name={props.name} />
            </div>
        </>
    )
);

export const ChooseSIdentityLimit = observer((props: {
    store: SIdentityStore | SIdentitySettingsStore | CardTanSettingsStore,
    name: string
}) => (
        <george.Card>
            <george.CardSectionTitle title={ui.__("sidentity.limit.header")} />
            <george.CardSectionContent>
                <pr.P_14_CONTENT>
                    {ui.__("sidentity.limit.subtitle.text")}
                </pr.P_14_CONTENT>
            </george.CardSectionContent>
            <pr.LightSeparatorLine style={{ marginTop: theme.MARGIN }} />
            <br />

            <george.CardSectionContent>
                <ChooseSIdentityLimitComponent store={props.store} name={props.name} />
            </george.CardSectionContent>
        </george.Card>
    )
);



// WEBPACK FOOTER //
// ./src/components/common/ChooseSIdentityLimit.tsx